import React from "react";
import { Spinner } from "react-bootstrap";
import './LoadingSpinner.css'

const LoadingSpinner = ({ message='Загрузка...', size='lg', containerHeight="auto" }) => {
    // Определяем высоту контейнера в зависимости от размера
    // const containerHeight = size === 'sm' ? 'auto' : 'vh-100'; ${containerHeight}
    
    return (
        <div className={`d-flex justify-content-center align-items-center ${containerHeight}`}> 
            <Spinner animation="border" role="status" size={size} />
            <span style={{marginLeft: '5px'}}>{message}</span>
        </div>
    );
};

export default LoadingSpinner;
